import { render } from "./DeletedMedicationPharmacies.vue?vue&type=template&id=e3b2868e&scoped=true"
import script from "./DeletedMedicationPharmacies.vue?vue&type=script&lang=js"
export * from "./DeletedMedicationPharmacies.vue?vue&type=script&lang=js"

import "./DeletedMedicationPharmacies.vue?vue&type=style&index=0&id=e3b2868e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b2868e"]])

export default __exports__